module.exports = __webpack_public_path__ + "assets/img/logo.33200bcf.png";